import { cur } from '@/lib/currency';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Edit, Trash2 } from 'lucide-react';

export function PlatformsList({ platforms, onEdit, onDelete }) {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      {platforms.map(platform => (
        <Card key={platform.id} className={`${!platform.is_active ? 'opacity-50' : ''}`}>
          <CardHeader className="pb-2">
            <CardTitle className="flex items-center justify-between">
              <div>
                <span className="font-outfit">{platform.name}</span>
                {platform.name_ar && <span className="text-sm text-muted-foreground ml-2">({platform.name_ar})</span>}
              </div>
              <div className="flex gap-1">
                <Button size="icon" variant="ghost" onClick={() => onEdit(platform)}><Edit size={14} /></Button>
                <Button size="icon" variant="ghost" className="text-error" onClick={() => onDelete(platform.id)}><Trash2 size={14} /></Button>
              </div>
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-1 text-sm">
              <div className="flex justify-between">
                <span className="text-muted-foreground">Commission:</span>
                <span className="font-medium">{platform.commission_rate || 0}%</span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Payment Terms:</span>
                <Badge variant="outline">{platform.payment_terms}</Badge>
              </div>
              {platform.pending_amount > 0 && (
                <div className="flex justify-between pt-2 border-t mt-2">
                  <span className="text-muted-foreground">Pending:</span>
                  <span className="font-bold text-error">{cur()} {platform.pending_amount.toLocaleString()}</span>
                </div>
              )}
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
